<template>
    <div style="height: 100vh; width: 100%; text-align: center; vertical-align: middle;">Account was deleted successful!</div>
</template>